var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as ethers from "ethers";
import BigNumber from 'bignumber.js';
import { DEFAULT_DECIMAL, RATES_ENDPOINTS } from "../constants";
import { CONTRACT_POINT_BASE_NUMBER } from "../constants/prices";
BigNumber.config({ DECIMAL_PLACES: 10, EXPONENTIAL_AT: 50 });
export function notNill(value) {
    return !!value;
}
export const point2Price = (point, decimalX = DEFAULT_DECIMAL, decimalY = DEFAULT_DECIMAL) => {
    return Math.pow(CONTRACT_POINT_BASE_NUMBER, point) * Math.pow(10, decimalX - decimalY);
};
export const price2Point = (price, decimalX, decimalY, margin = 1) => {
    price = price * Math.pow(10, decimalY - decimalX);
    const pt = Number((Math.log(price) / Math.log(1.0001)).toFixed());
    return Math.floor(pt / margin) * margin;
};
export const realPrice2PlainPrice = (price, decimalX = DEFAULT_DECIMAL, decimalY = DEFAULT_DECIMAL) => {
    return price / Math.pow(10, decimalY - decimalX);
};
export const plainPrice2RealPrice = (price, decimalX = DEFAULT_DECIMAL, decimalY = DEFAULT_DECIMAL) => {
    return price * Math.pow(10, decimalY - decimalX);
};
export const calcBlockHeight = (relativeTime, provider) => __awaiter(void 0, void 0, void 0, function* () {
    if (relativeTime > 0) {
        relativeTime = 0;
    }
    const blockNumber = yield provider.getBlockNumber();
    const networkId = (yield (provider.getNetwork())).chainId;
    const rate = RATES_ENDPOINTS[networkId.toString()];
    const targetBlockNumber = Math.floor(blockNumber + relativeTime / rate);
    return targetBlockNumber >= 1 ? targetBlockNumber : 1;
});
export const calcRealTime = (blockHeight, provider) => __awaiter(void 0, void 0, void 0, function* () {
    const networkId = (yield (provider.getNetwork())).chainId;
    const blockNumber = yield provider.getBlockNumber();
    const rate = RATES_ENDPOINTS[networkId];
    const relativeTime = (blockHeight - blockNumber) * rate;
    const now = new Date();
    const ret = new Date(now.setSeconds(now.getSeconds() + relativeTime));
    return ret;
});
export const toPlainAmount = (realAmount, decimal = DEFAULT_DECIMAL) => {
    const amountStr = realAmount.toFixed(decimal);
    return ethers.BigNumber.from(BigNumber(amountStr).shiftedBy(decimal).toString());
};
export const toRealAmount = (plainAmount, decimal = DEFAULT_DECIMAL) => {
    // return plainAmount.div(ethers.BigNumber.from(10).pow(decimal)).toNumber();
    return BigNumber(plainAmount.toString()).shiftedBy(-decimal).toNumber();
};
